import { types } from './actions';

const initialState = {
  actionModalType: null,
  table: null,
  tableData: null,
  isActionModalOpen: false,
  isUpdatingTable: false,
};

const reducer = (state = initialState, action) => {
  const { payload, type } = action;
  switch (type) {
    case types.INIT:
      return {
        ...state,
        table: payload.table,
      };
    case types.RECEIVE_TABLE_DATA:
      return {
        ...state,
        tableData: payload.tableData,
      };
    case types.ACTION_MODAL_OPEN:
      return {
        ...state,
        isActionModalOpen: true,
        actionModalType: payload.type,
      };
    case types.ACTION_MODAL_CLOSE:
      return {
        ...state,
        isActionModalOpen: false,
      };
    case types.UPDATE_CUSTOM_TABLE_REQUEST:
    case types.RENAME_CUSTOM_TABLE_REQUEST:
    case types.DELETE_CUSTOM_TABLE_REQUEST:
      return {
        ...state,
        isUpdatingTable: true,
      };
    case types.UPDATE_CUSTOM_TABLE_ERROR:
    case types.RENAME_CUSTOM_TABLE_ERROR:
    case types.DELETE_CUSTOM_TABLE_ERROR:
      return {
        ...state,
        isUpdatingTable: false,
      };
    case types.UPDATE_CUSTOM_TABLE_SUCCESS:
    case types.RENAME_CUSTOM_TABLE_SUCCESS:
      return {
        ...state,
        isUpdatingTable: false,
        table: payload.table,
      };
    case types.DELETE_CUSTOM_TABLE_SUCCESS:
      return {
        ...state,
        isUpdatingTable: false,
      };
    default:
      return state;
  }
};

export default reducer;

const getScope = (state) => state.modules.supplierTables.detailsPage;

export const getTableId = (state) => (getScope(state).table || {}).id;

export const getTableName = (state) => (getScope(state).table || {}).name;

export const getTableData = (state) => getScope(state).tableData;

export const getIsActionModalOpen = (state) =>
  getScope(state).isActionModalOpen;

export const getActionModalType = (state) => getScope(state).actionModalType;

export const getRelatedEntities = (state) =>
  (getScope(state).table || {}).relatedEntities || [];

export const getIsUpdatingTable = (state) => getScope(state).isUpdatingTable;
